import { Settings } from 'luxon'
import i18n from '../i18n';
import axios from '@/util/axios';

const state = {
    current: {},
    all: [{
        code: 0,
        locale: 'pl',
        img: require("@/assets/img/lang/pl.png")
    },
    {
        code: 1,
        locale: 'en',
        img: require("@/assets/img/lang/en.png")
    }]
};

// getters
const getters = {
    current: (state) => {
        if (!state.current.locale) {
            return state.all[1]; // EN is default
        }

        return state.current;
    },
    all: (state) => {
        return state.all
    }
}

// actions
const actions = {
    changeCurrent({ commit }, payload) {

        let locale = payload.locale;
        document.querySelector('html').setAttribute('lang', locale);
        axios.defaults.headers.common['Accept-Language'] = locale

        Settings.defaultLocale = i18n.locale = locale

        commit('setCurrent', payload);
    },
}

// mutations
const mutations = {
    setCurrent(state, payload) {
        state.current = payload;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}